var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-gallery-comp"},[_c('div',[_c('v-img',{attrs:{"src":_vm.pic1Url}})],1),_c('div',[_c('v-img',{attrs:{"src":_vm.pic2Url}})],1),_c('div',[_c('v-img',{attrs:{"src":_vm.pic3Url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }